export const geoJsonFilePath = 'data/qld_lga.geo.json';
export const hhsDataFilePath = 'data/hhs-data.json';
export const dataFilePath = 'data/data.json';

export const entityTypes = {
  DOT: 'Department of Transport',
  STATUTORY: 'Statutory Authorities',
  PORT: 'Government owned corporations (Ports)',
};



// WEBPACK FOOTER //
// ./src/config/index.js